// getters
const schoolRoutesNews = state => state.schoolRoutesNews

export default {
  schoolRoutesNews
}



// WEBPACK FOOTER //
// ./src/store/modules/schoolroutes/news/getters.js